module.exports = __webpack_public_path__ + "img/withdraw_disable.e268fbd2.svg";